import React, { useEffect } from 'react'
import BangGiaQuayChup from '../../components/BangGiaQuayChup'
import ScrollToTop from "../../components/ScrollToTop";
import BangGiaQuayChupBanner from '../../components/Banner/BangGiaQuayChupBanner';
export default function BangGia() {
    useEffect(() => {
        document.title = 'MinMin Wedding - Phóng Sự Cưới | Bảng giá quay';
    }, []);
    return (
        <>
            <ScrollToTop />
            <BangGiaQuayChupBanner />
            <div>
                <BangGiaQuayChup />
            </div>

        </>
    )
}